import { IsoLanguagesRegions } from '@brandfolder/utilities';
import bg from 'date-fns/locale/bg';
import cs from 'date-fns/locale/cs';
import de from 'date-fns/locale/de';
import el from 'date-fns/locale/el';
import enAU from 'date-fns/locale/en-AU';
import enCA from 'date-fns/locale/en-CA';
import enGB from 'date-fns/locale/en-GB';
import enIN from 'date-fns/locale/en-IN';
import enNZ from 'date-fns/locale/en-NZ';
import enUS from 'date-fns/locale/en-US';
import enZA from 'date-fns/locale/en-ZA';
import es from 'date-fns/locale/es';
import fi from 'date-fns/locale/fi';
import fr from 'date-fns/locale/fr';
import frCA from 'date-fns/locale/fr-CA';
import frCH from 'date-fns/locale/fr-CH';
import hu from 'date-fns/locale/hu';
import it from 'date-fns/locale/it';
import ja from 'date-fns/locale/ja';
import ko from 'date-fns/locale/ko';
import nb from 'date-fns/locale/nb';
import nl from 'date-fns/locale/nl';
import nlBE from 'date-fns/locale/nl-BE';
import pl from 'date-fns/locale/pl';
import pt from 'date-fns/locale/pt';
import ro from 'date-fns/locale/ro';
import ru from 'date-fns/locale/ru';
import sv from 'date-fns/locale/sv';
import th from 'date-fns/locale/th';
import tr from 'date-fns/locale/tr';
import vi from 'date-fns/locale/vi';
import zhCN from 'date-fns/locale/zh-CN';
import zhTW from 'date-fns/locale/zh-TW';
import "../enums/accordion.js";
import "../enums/alert.js";
import "../enums/avatar.js";
import "../enums/breakpoints.js";
import "../enums/button.js";
import "../enums/code-editor.js";
import "../enums/colors.js";
import "../enums/combobox.js";
import { DateInputFormats, DateInputParsings, DateInputPlaceholders } from "../enums/date.js";
import "../enums/drag-and-drop.js";
import "../enums/dialog.js";
import "../enums/divider.js";
import "../enums/dropdown.js";
import "../enums/fieldset.js";
import "../enums/font-icon.js";
import "../enums/fonts.js";
import "../enums/headings.js";
import "../enums/input.js";
import "../enums/keys.js";
import "../enums/list.js";
import "../enums/listbox.js";
import "../enums/loader.js";
import "../enums/margin.js";
import "../enums/option.js";
import "../enums/pill.js";
import "../enums/placements.js";
import "../enums/popout.js";
import "../enums/privacy.js";
import "../enums/radio-group.js";
import "../enums/status.js";
import "../enums/switch.js";
import "../enums/table.js";
import "../enums/tooltip.js";
import "../enums/transitions.js";
import "../enums/widths.js";
var datePickerInputFormats = [{
  format: DateInputFormats.DMY,
  parse: DateInputParsings.DMY,
  placeholder: DateInputPlaceholders.DMY
}, {
  format: DateInputFormats.MDY,
  parse: DateInputParsings.MDY,
  placeholder: DateInputPlaceholders.MDY
}, {
  format: DateInputFormats.YMD,
  parse: DateInputParsings.YMD,
  placeholder: DateInputPlaceholders.YMD
}];
/**
 * Get a date-fns Locale and DatePickerInputFormat from a given ISO language code.
 * NOTE: Boulder only supports two letter codes right now, like "en".
 * This function also handles region, like "en-US", which is needed for proper date input formatting.
 * @param locale string | undefined
 * @returns InputFormatLocale
 */
var getInputFormatLocale = function getInputFormatLocale(locale) {
  switch (locale) {
    case IsoLanguagesRegions.BG:
      {
        return {
          locale: bg,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.CS:
      {
        return {
          locale: cs,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.DE:
      {
        return {
          locale: de,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.EL:
      {
        return {
          locale: el,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.EN_AU:
      {
        return {
          locale: enAU,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.EN_CA:
      {
        return {
          locale: enCA,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.EN_GB:
      {
        return {
          locale: enGB,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.EN_IN:
      {
        return {
          locale: enIN,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.EN_NZ:
      {
        return {
          locale: enNZ,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.EN_ZA:
      {
        return {
          locale: enZA,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.ES:
      {
        return {
          locale: es,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.FI:
      {
        return {
          locale: fi,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.FR:
      {
        return {
          locale: fr,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.FR_CA:
      {
        return {
          locale: frCA,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.FR_CH:
      {
        return {
          locale: frCH,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.HU:
      {
        return {
          locale: hu,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.IT:
      {
        return {
          locale: it,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.JA:
      {
        return {
          locale: ja,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.KO:
      {
        return {
          locale: ko,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.NB:
      {
        return {
          locale: nb,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.NL:
      {
        return {
          locale: nl,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.NL_BE:
      {
        return {
          locale: nlBE,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.PL:
      {
        return {
          locale: pl,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.PT:
      {
        return {
          locale: pt,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.RO:
      {
        return {
          locale: ro,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.RU:
      {
        return {
          locale: ru,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.SV:
      {
        return {
          locale: sv,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.TH:
      {
        return {
          locale: th,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.TR:
      {
        return {
          locale: tr,
          inputFormat: datePickerInputFormats[0]
        };
      }
    case IsoLanguagesRegions.VI:
      {
        return {
          locale: vi,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.ZH:
      {
        return {
          locale: zhCN,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.ZH_CN:
      {
        return {
          locale: zhCN,
          inputFormat: datePickerInputFormats[2]
        };
      }
    case IsoLanguagesRegions.ZH_TW:
      {
        return {
          locale: zhTW,
          inputFormat: datePickerInputFormats[2]
        };
      }
    default:
      {
        // en (same as en-US)
        return {
          locale: enUS,
          inputFormat: datePickerInputFormats[1]
        };
      }
  }
};
export { getInputFormatLocale };